/* import __COLOCATED_TEMPLATE__ from './common.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import View from 'embercom/objects/inbox/inboxes/view';
import type InboxApi from 'embercom/services/inbox-api';
import type InboxState from 'embercom/services/inbox-state';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

type Config = {
  title: string;
  description: string;
  linkText: string;
  articleId: number;
  icon: InterfaceIconName;
};

export default class Inbox2LeftNavFoldersDefaultAiChatbotZeroState extends Component {
  @service declare inboxApi: InboxApi;
  @service declare inboxState: InboxState;
  @service declare intercomEventService: any;

  get config(): Config {
    if (this.isResolvedInbox) {
      return {
        title: 'inbox.inbox-list.ai-chatbot.resolved.zero-state.title',
        description: 'inbox.inbox-list.ai-chatbot.resolved.zero-state.description',
        linkText: 'inbox.inbox-list.ai-chatbot.resolved.zero-state.link-text',
        articleId: 8205718,
        icon: 'thumbsup',
      };
    }

    if (this.isRoutedInbox) {
      return {
        title: 'inbox.inbox-list.ai-chatbot.routed.zero-state.title',
        description: 'inbox.inbox-list.ai-chatbot.routed.zero-state.description',
        linkText: 'inbox.inbox-list.ai-chatbot.routed.zero-state.link-text',
        articleId: 7860256,
        icon: 'new-direct-message',
      };
    }

    if (this.isAbandonedInbox) {
      return {
        title: 'inbox.inbox-list.ai-chatbot.abandoned.zero-state.title',
        description: 'inbox.inbox-list.ai-chatbot.abandoned.zero-state.description',
        linkText: 'inbox.inbox-list.ai-chatbot.abandoned.zero-state.link-text',
        articleId: 7860256,
        icon: 'tooltip',
      };
    }

    return {
      title: 'inbox.inbox-list.ai-chatbot.all-conversations.zero-state.title',
      description: 'inbox.inbox-list.ai-chatbot.all-conversations.zero-state.description',
      linkText: 'inbox.inbox-list.ai-chatbot.all-conversations.zero-state.link-text',
      articleId: 7860256,
      icon: 'fin',
    };
  }

  get isAllConversationsInbox() {
    return (
      this.inboxState.activeInbox instanceof View &&
      this.inboxState.activeInbox.viewSummary.systemType === 'ai_agent_all_conversations'
    );
  }

  get isResolvedInbox() {
    return (
      this.inboxState.activeInbox instanceof View &&
      this.inboxState.activeInbox.viewSummary.systemType === 'ai_agent_resolved'
    );
  }

  get isRoutedInbox() {
    return (
      this.inboxState.activeInbox instanceof View &&
      this.inboxState.activeInbox.viewSummary.systemType === 'ai_agent_routed'
    );
  }

  get isAbandonedInbox() {
    return (
      this.inboxState.activeInbox instanceof View &&
      this.inboxState.activeInbox.viewSummary.systemType === 'ai_agent_abandoned'
    );
  }

  get openedInbox() {
    if (this.inboxState.activeInbox instanceof View) {
      return this.inboxState.activeInbox.viewSummary.systemType;
    }

    return null;
  }

  @action
  openArticle(event: MouseEvent) {
    event.preventDefault();

    window.Intercom('showArticle', this.config.articleId);
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: `zero_state_link_${this.openedInbox}`,
      place: 'inbox',
      section: 'inbox_conversations_ai_chatbot_zero_state',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::Folders::Default::AiChatbot::ZeroState::Common': typeof Inbox2LeftNavFoldersDefaultAiChatbotZeroState;
  }
}
